<div class="auth-container">
  <div class="row auth-main">
    <div class="col-sm-6 px-0 d-none d-sm-flex">
      <video class="left-vid" muted loop autoplay>
        <source src="../../assets/videos/sign-in-ribbon-loop.mp4" type="video/mp4">
      </video>
    </div>
    <div class="col-sm-6 auth-form-section">
      <div class="form-section">

        <div class="auth-wrapper">
          <div class="header-img mx-auto my-auto" style="background-image: url(../../assets/images/northrow-logo.png);">
          </div>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
